"use client"
import React, { useState, useEffect } from 'react';
import { Container, Drawer } from '@mui/material';
import { getHeader, getHeaderNavMain } from "@/app/utils/request/requestList";
import "@/app/style/headernav.scss";
import _ from 'lodash';
import { switchLanguage, openTarget, openNewWindow } from "@/app/utils/Common";
import { LANGTYPE_EN, LANGUAGE, str2LangCode, useLanguage } from '@/app/utils/LanguageContext';
import SearchIcon from '@mui/icons-material/Search';
import { redirectPage, theme, getLoginInfo} from "@/app/utils/Common";
import "@/app/style/comm.scss";
import cookie from 'react-cookies';
import Script from 'next/script';
import SubMenu from "./subMenu";

type propType = {
  data?: any;
};

const HeaderNav = (props: propType) => {
  const { state: lang } = useLanguage();
  const { t: dict } = lang;
  const [headerData, setHeader] = useState<any>();
  const [open, setMainMenuOpen] = useState<boolean>(false);
  const [mainMenu, setMainMenu] = useState<any[]>([]);
  // const [raceSiteMenu, setRaceSiteMenu] = useState<any[]>([]);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [showDisplayName, setShowDisplayName] = useState("");

  const toggleMainMenu = (open: boolean) => () => {
    setMainMenuOpen(open);
  };
  const [simulcastMainMenu, setSimulcastMainMenu] = useState<any>(null);
  const clientQuery = props.data?.simulcastMainMenu;
  useEffect(() => {
    setSimulcastMainMenu(clientQuery);
  }, [])

  const changeMenu = (e: any, hiddenId: string, displayId: string) => {
    const hideElement = document.getElementById(hiddenId);
    if (!!hideElement) hideElement.className = "inactive";
    const displayElement = document.getElementById(displayId);
    if (!!displayElement) displayElement.className = "active";
  }

  useEffect(() => {
    getHeaderNavMain({language: lang.langCode}).then((res: any) => {
        normalizeMainMenu(res);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {  
      getLoginStatus(); 
  }, []);
  let count = 0;
  const getLoginStatus = () => {
    const isUserProfileLoaded = localStorage.getItem("IsUserProfileLoaded");
    console.log("getLoginInfo getLoginStatus isUserProfileLoaded", isUserProfileLoaded)
    if(count <= 10 && (isUserProfileLoaded == "false" || !isUserProfileLoaded)) { 
        setTimeout(() => {
          count++;
          console.log("getLoginInfo Mobile getLoginStatus no")
          return getLoginStatus()
        }, 1000);  
    } else if (isUserProfileLoaded || count > 10 || WCIPCookie.isLoggedIn()
      ){
      console.log("getLoginInfo Mobile getLoginStatus end")
      refreshGlobalLoginControl();
    }
  };

  const refreshGlobalLoginControl = () => {
    const custProIn = cookie.load("custProIn");
    const {isLogin, displayName} = getLoginInfo(custProIn, lang.langType);
    setIsLogin(isLogin);
    setShowDisplayName(displayName);
    console.log("getLoginInfo", isLogin, displayName, window.WCIPCookie?.isLoggedIn())
  };

  useEffect(() => {
    getHeader({language: lang.langCode}).then((res: any) => {
        const data = res?.item;
        if (data !== null && data !== undefined) {
          setHeader(data);
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, []);
  
  const normalizeMainMenu = (res: any) => {
    console.log('[-----normalizeMainMenu]', res)
    const data = res?.item?.data;
    if (data !== null && data !== undefined) {
      _.forEach(data, function(item1) {
        item1.seqIndex = Number(item1?.seq?.value || "999") ;
        if(item1.children !== null && item1.children !== undefined){
            item1.children?.sort((a:any, b:any) => {
              return a?.seq?.value - b?.seq?.value
            })
          _.forEach(item1.children, function(item2) {
            item2.seqIndex = Number(item2?.seq?.value || "999") ;
            if(item2.children !== null && item2.children !== undefined){
              item2.children?.sort((a:any, b:any) => {
                return a?.seq?.value - b?.seq?.value
              })
              _.forEach(item2.children, function(item3) {
                item3.seqIndex = Number(item3?.seq?.value || "999") ;
                if(item3.children !== null && item3.children !== undefined){
                  item3.children?.sort((a:any, b:any) => {
                    return a?.seq?.value - b?.seq?.value
                  })
                  _.forEach(item3.children, function(item4) {
                    item4.seqIndex = Number(item4?.seq?.value || "999") ;
                  });
                }
              });
            }
          });
        }
      });
      const sortedData = _.sortBy(data, ['seqIndex']); 
      setMainMenu(sortedData);
    }
  }

  const subMena = _.sortBy((mainMenu.filter((item) => item.name === '02-Racing' && item.label.value)[0]?.children || []), ['seqIndex']);
  return (
    <>
      <Container disableGutters maxWidth={false} sx={{ display: { lg: 'block' } }}>
        <div className="nav-block" id="mainNav">
          <div className="nav-block">
            <div className="container">
              <div className={`${lang.langType === LANGTYPE_EN?"navbar": "navbar_ch"}`} >
                <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1" style={{ width: 952}}>
                  <nav className="main-nav nav-en">
                    <ul className={`nav nav-level-1 ${lang.langType === LANGTYPE_EN?"": "nav-level-1-ch"} commBContent`} style={{padding: "0"}}>
                      {mainMenu.map((item, index) => {
                        if (item.label?.value) {
                          return (
                            <li key={"nav" + index} id={item.name} style={{ borderLeft: index === 0 ? '1px solid #003c84' : '', borderRight: index === mainMenu.length - 1 ? '1px solid #003c84' : '' }}>
                              {item.name === '02-Racing' ? (<a className='active' target={openNewWindow(item?.target?.value)} href={item.link?.value || 'javascript:;'}>{item.label?.value}</a>) : (<a target={openNewWindow(item?.target?.value)} href={item.link?.value || 'javascript:;'}>{item.label?.value}</a>)}
                            </li>
                          )
                        }
                      })}
                    </ul>
                  </nav>
                  <nav className="second-nav" id="second-nav-container">
                    <ul className={`dropdown ${lang.langType === LANGTYPE_EN?"": "dropdown_ch"} navbar-hkjc index commBContent`} id="nav-racing">
                      {subMena.map((sub: any, idx:any) => {
                        if (sub?.label?.value) {
                          return (
                            <li key={`subMena_${idx}`} onMouseLeave={hideSubMenu}>
                              <a id={sub.name} href={sub.link.value || 'javascript:;'} target={openNewWindow(sub?.target?.value)} onMouseEnter={displaySubMenu}>{sub?.label?.value}</a>
                              <ul>
                                {!!sub.children ? _.sortBy(sub.children, ['seqIndex']).map((lvl: any, i: number) => {
                                  if (lvl.label.value) {
                                    return (
                                      <li key={`sub_${i}`}>
                                        <a id={lvl.name} href={lvl.link.value} target={openNewWindow(lvl?.target?.value)} className={lvl.children?.filter((i:any) => i?.label?.value && i?.link?.value).length > 0 ? 'nav-arrow' : ''} onMouseEnter={displaySubMenu2}>{lvl.label.value}</a>
                                        <ul>
                                          {!!lvl.children ? _.sortBy(lvl.children, ['seqIndex']).map((last: any, j: number) => {
                                            if (last.label.value) {
                                              return (
                                                <li key={`last_${j}`}>
                                                  <a id={last.name} href={last.link.value} target={openNewWindow(last?.target?.value)}>{last.label.value}</a>
                                                </li>
                                              )
                                            }
                                          }) : <></>}
                                        </ul>
                                      </li>
                                    )
                                  }
                                }) : <></>}
                              </ul>
                            </li>
                          )
                        }
                      })
                      }
                    </ul>
                  </nav>
                </div>
                <div className="clear"></div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* <Script src={`${assetPrefix}/js/loadSSO.js`}   /> */}
      <SubMenu subData={mainMenu}/>
      </>

  );
}

function displaySubMenu(e: any) {
  e.preventDefault();
  e.target.parentElement.parentElement.classList.add('dim');
  e.target.classList.add('active');
  e.target.parentElement.parentElement.classList.remove('first');
  adjustPosition(e.target, e.target.nextElementSibling)
}

function displaySubMenu2(e: any) {
  e.preventDefault();
  adjustPosition2(e.target, e.target.nextElementSibling);
  
}

function adjustPosition(curentTab:any, ele:any) {
  const rect = curentTab.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  if(viewportWidth - rect.right < 210) {
    ele.style.left = 'auto';
    ele.style.right = '0';
  } else {
    ele.style.left = '0';
    ele.style.right = 'auto';
  }
}
function hideSubMenu(e: any) {
  e.preventDefault();
  e.target.parentElement.parentElement.classList.remove('dim');
  const children = e.target.parentElement.children;
  for (const child of children) {
    child.classList.remove('active');
  }
  e.target.parentElement.parentElement.classList.remove('first');
}
function adjustPosition2(curentTab:any, ele:any) {
  const rect = curentTab.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  if(viewportWidth - rect.right < 210) {
    ele.style.left = 'auto';
    ele.style.right = '100%';
  } else {
    ele.style.left = '100%';
    ele.style.right = 'auto';
  }
}
function waTracker(name: string) {
  console.log('tracker name: ', name);
  // WATracker.trackClickEvent(name)
}

export default HeaderNav